module.exports = __webpack_public_path__ + "img/intro_uk.9e131148.svg";